import { GET, POST } from '@sisyphe/utils'

/** ID登录 */
export function idLogin(params) {
  return POST('/api/access/accountLogin', params)
}

/** 检测账号可用性 */
export function preLogin(params) {
  return POST('/api/access/preLogin', params)
}

/** 发送短信验证码 */
export function sendSms(params) {
  return POST('/api/access/sendSms', params)
}

/** 验证码登录 */
export function phoneLogin(params) {
  return POST('/api/access/phoneLogin', params)
}

/** 重置密码 */
export function resetPassword(params) {
  return POST('/api/access/resetPassword', params)
}

/** 企业微信登录 */
export function qyWeChatLogin(params) {
  return POST('/api/access/qyWeChatLogin', params)
}

/** 阅历 */
export function calendar(params) {
  return GET('/api/access/calendar', params)
}

/** 登出 */
export function logout(params) {
  return GET('/api/access/logout', params)
}

/** 获取会话信息 */
export function tokenCheck(params) {
  return POST('/api/access/tokenCheck', params)
}

/** 添加信任设备 */
export function addTrustDevice(params) {
  return POST('/api/access/addTrustDevice', params)
}
